import type { ActionProps } from '../types';

export const ToggleElement = ({
  className,
  handleOnClick,
  title,
  disabled,
  disabledTranslation,
  testID,
  value,
}: ActionProps) => (
  <label
    data-testid={testID}
    className={className}
    title={disabledTranslation && disabled ? disabledTranslation.title : title}>
    <input
      type="checkbox"
      onChange={() => handleOnClick()}
      disabled={disabled && !disabledTranslation}
      checked={value}
    />
  </label>
);

ToggleElement.displayName = 'ToggleElement';
